// src/components/inputs/InputFactory.js

import BoolInput from "../inputs/BoolInput";
import CodeInput from "../inputs/CodeInput";
import IntInput from "../inputs/IntInput";
import MapInput from "../inputs/MapInput";
import OptionInput from "../inputs/OptionInput";
import PropTypes from "prop-types";
import React from "react";
import StringInput from "../inputs/StringInput";

/**
 * InputFactory generates the appropriate input component based on the type.
 * @param {string} type - The type of input ('int', 'bool', 'option', 'string', etc.)
 * @param {object} props - Props to pass to the input component.
 * @returns {React.Component|null} - The corresponding input component or null if type is unrecognized.
 */
const InputFactory = ({ type, ...props }) => {
  switch (type) {
    case "int":
      return <IntInput {...props} />;
    case "bool":
      return <BoolInput {...props} />;
    case "option":
      return <OptionInput {...props} />;
    case "string":
    case "timestamp":
    case "timedelta":
      return <StringInput {...props} />;
    case "code":
      return <CodeInput {...props} />;
    case "map":
      return <MapInput {...props} />;
    default:
      console.warn(`Unsupported input type: ${type}`);
      return null;
  }
};

InputFactory.propTypes = {
  type: PropTypes.string.isRequired,
  props: PropTypes.object.isRequired,
};

export default InputFactory;
